import _ from 'lodash'

// Update a value in our template store
const updateTemplate = ({ newTemplate, setNewTemplate, datapath, value }) => {
  try {
    cloneAndUpdate({ source: newTemplate, updater: setNewTemplate, path: datapath, value })
  }
  catch (err) {
    console.error("popup-editor-utils:updateTemplate error", err)
  }
}

// Update a value in our class
const updateClass = ({ newClassData, setNewClassData, datapath, value }) => {
  try {
    cloneAndUpdate({ source: newClassData, updater: setNewClassData, path: datapath, value })
   }
  catch (err) {
    console.error("popup-editor-utils:updateClass error", err)
  }
}

// Update a value in our object
const updateObject = ({ newObjectData, setNewObjectData, datapath, value }) => {
  try {
    cloneAndUpdate({ source: newObjectData, updater: setNewObjectData, path: datapath, value })
  }
  catch (err) {
    console.error("popup-editor-utils:updateObject error", err)
  }
}

// Update a value in our instance data store
const updateInstanceData = ({ newTemplate, newInstanceData, setNewInstanceData, datapath, value }) => {
  try {
    // get the path to our newInstanceData value 
    let InstanceDataPath = _.get(newTemplate, datapath).replace(/[{}]/g, "")
    cloneAndUpdate({ source: newInstanceData, updater: setNewInstanceData, path: InstanceDataPath, value })
  }
  catch (err) {
    console.error("popup-editor-utils:updateInstanceData error", err)
  }
}

// Makes a copy of a controlled data source, applies a change and stores the new value back to the data source
const cloneAndUpdate = ({ source, updater, path, value }) => {
  try {
    let temp = _.cloneDeep(source)
    _.set(temp, path, value)
    updater(temp)
  }
  catch (err) {
    console.error("popup-editor-utils:cloneAndUpdate error", err)
  }
}

// Makes a copy of a controlled data source removes an item and inserts a different one
const cloneAndReplace = ({ source, updater, removePath, removeIndex, insertPath, insertItem }) => {
  try {
    let temp = _.cloneDeep(source)

    // Remove item
    let dataArray1 = _.get(temp,removePath)
    dataArray1.splice(removeIndex, 1)

    // Insert item
    let dataArray2 = _.get(temp,insertPath)
    dataArray2.push(insertItem)
    
    updater(temp)
  }
  catch (err) {
    console.error("popup-editor-utils:cloneAndUpdate error", err)
  }
}


// Makes a copy of a controlled data source, inserts an item and stores the new value back to the data source
const cloneAndInsert = ({ source, updater, path, tabValue, value }) => {
  try {
    let temp = _.cloneDeep(source)

    // Depending upon what we are updating, we may or may not have a path item
    let dataArray = !!path ? _.get(temp,path) : temp

    dataArray.push(value)

    // Move new item to the requires insert point (just after tabValue)
    if (dataArray.length > 1) moveArrayItem(dataArray, dataArray.length - 1, tabValue + 1)

    updater(temp)

    return dataArray.length
  }
  catch (err) {
    console.error("popup-editor-utils:cloneAndInsert error", err)
  }
}

// Makes a copy of a controlled data source, removes an item (from an array) and stores the new value back to the data source
const cloneAndRemove = ({ source, updater, path, tabValue, keyPrefix }) => {
  try {
    let temp = _.cloneDeep(source)

    // Depending upon what we are updating, we may or may not have a path item
    let dataArray = !!path ? _.get(temp,path) : temp

    // If we are removing from the middle of the array we need to splice
    if (dataArray.length > 1) {
      dataArray.splice(tabValue, 1)
      dataArray.map((f, idx) => {
        if (f.key) f.key = f.key.match(/__SMARTIX_/) ? f.key : keyPrefix + idx
      })
    } else {
      dataArray.pop()
    }

    updater(temp)

    return dataArray.length
  }
  catch (err) {
    console.error("popup-editor-utils:cloneAndRemove error", err)
  }
}


// Move an item in an array to a new location
const moveArrayItem = (arr, old_index, new_index) => {
  try {
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1
      while (k--) {
        arr.push(undefined)
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0])
  }
  catch (err) {
    console.error("popup-editor-utils:moveArrayItem error", err)
  }
}

// Move a field left (or up for back fields)
const  moveFieldLeft = ({newTemplate,dataSource,setNewTemplate,setDataSource,path,currentPosition}) => {
  try {
    const nt = _.clone(newTemplate)
    const ds = _.clone(dataSource)
    moveArrayItem(_.get(nt,path), currentPosition, currentPosition - 1)
    moveArrayItem(ds, currentPosition, currentPosition - 1)
    setNewTemplate(nt)
    setDataSource(ds)
  }
  catch (err) {
    console.error("popup-editor-utils:moveFieldLeft error", err)
  }
}

// Move a field right (or down for back fields)
const  moveFieldRight = ({newTemplate,dataSource,setNewTemplate,setDataSource,path,currentPosition}) => {
  try {
    const nt = _.clone(newTemplate)
    const ds = _.clone(dataSource)
    moveArrayItem(_.get(nt,path), currentPosition, currentPosition + 1)
    moveArrayItem(ds, currentPosition, currentPosition + 1)
    setNewTemplate(nt)
    setDataSource(ds)
  }
  catch (err) {
    console.error("popup-editor-utils:moveFieldRight error", err)
  }
}

// Delete $path from source
const deleteDataItem = ({source,updater,path}) => {
  try {
    let temp = _.cloneDeep(source)
    _.unset(temp, path)
    updater(temp)
  }
  catch (err) {
    console.error("popup-editor-utils:deleteDataItem error", err)
  }
}

export default {
  updateTemplate,
  updateClass,
  updateObject,
  updateInstanceData,
  cloneAndUpdate,
  cloneAndInsert,
  cloneAndRemove,
  cloneAndReplace,
  moveArrayItem,
  moveFieldLeft,
  moveFieldRight,
  deleteDataItem,
}